var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 42,
    viewBox: "0 0 220 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2997 13.6254V35.464H59.2457V26.5086H49.3246V35.464H44.2705V13.6254H49.3246V22.2352H59.2457V13.6254H64.2997Z",
    fill: "#1B1F3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8857 27.0718C67.8857 22.0177 71.7851 18.4294 77.1197 18.4294C82.4543 18.4294 86.3252 22.0177 86.3252 27.0718C86.3252 32.1258 82.4624 35.7141 77.1197 35.7141C71.7769 35.7141 67.8857 32.1258 67.8857 27.0718ZM81.3951 27.0718C81.3951 24.1707 79.5532 22.4223 77.1258 22.4223C74.6984 22.4223 72.8219 24.1707 72.8219 27.0718C72.8219 29.9729 74.6943 31.7192 77.1258 31.7192C79.5573 31.7192 81.3951 29.9729 81.3951 27.0718Z",
    fill: "#1B1F3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.48 18.6793V35.4639H101.859V33.4675C100.58 34.9333 98.7081 35.7139 96.6486 35.7139C92.4383 35.7139 89.4741 33.3414 89.4741 28.1633V18.6793H94.3412V27.4457C94.3412 30.2533 95.5894 31.5015 97.7424 31.5015C99.9787 31.5015 101.605 30.0662 101.605 26.9781V18.6793H106.48Z",
    fill: "#1B1F3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.096 12.3101V35.464H123.448V33.5286C122.229 34.9964 120.454 35.7141 118.207 35.7141C113.464 35.7141 109.815 32.3434 109.815 27.0718C109.815 21.8002 113.474 18.4294 118.207 18.4294C120.267 18.4294 122.013 19.0841 123.229 20.4624V12.3101H128.096ZM123.322 27.0677C123.322 24.1666 121.452 22.4182 119.053 22.4182C116.654 22.4182 114.747 24.1666 114.747 27.0677C114.747 29.9688 116.619 31.7152 119.053 31.7152C121.486 31.7152 123.322 29.9729 123.322 27.0718V27.0677Z",
    fill: "#1B1F3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.995 13.6253C131.995 12.0965 133.215 10.9113 135.02 10.9113C136.826 10.9113 138.047 12.0335 138.047 13.5318C138.047 15.1582 136.828 16.3394 135.02 16.3394C133.213 16.3394 131.995 15.1562 131.995 13.6253ZM132.589 18.6794H137.454V35.464H132.589V18.6794Z",
    fill: "#1B1F3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.135 25.854V35.4641H154.27V26.6042C154.27 23.8901 153.022 22.6418 150.869 22.6418C148.529 22.6418 146.844 24.0772 146.844 27.1653V35.4641H141.977V18.6795H146.626V20.6454C147.935 19.2101 149.901 18.4294 152.178 18.4294C156.141 18.4294 159.135 20.7389 159.135 25.854Z",
    fill: "#1B1F3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.883 18.6793L172.302 36.5027C170.675 40.5586 168.37 41.7764 165.345 41.7764C163.629 41.7764 161.757 41.2132 160.669 40.2476L162.448 36.7914C163.209 37.4568 164.181 37.8325 165.192 37.8527C166.534 37.8527 167.282 37.2611 167.937 35.7627L168 35.6062L160.732 18.6976H165.754L170.464 30.0825L175.207 18.6976L179.883 18.6793Z",
    fill: "#1B1F3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.431 30.7839H195.293L193.357 35.4598H188.179L197.913 13.6212H202.904L212.663 35.4598H207.367L205.431 30.7839ZM203.84 26.9476L200.383 18.5879L196.927 26.9476H203.84Z",
    fill: "url(#paint0_linear_702_3897)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.946 13.6254H220V35.464H214.946V13.6254Z",
    fill: "url(#paint1_linear_702_3897)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62919 34.5324C8.31407 32.9608 8.00505 31.4036 7.6757 29.7528C7.4724 29.9276 7.34432 30.0252 7.2264 30.1289C5.75247 31.3995 4.27041 32.662 2.81071 33.9509C2.65837 34.1102 2.45612 34.2126 2.23756 34.2411C2.01899 34.2696 1.79727 34.2224 1.6092 34.1075C0.97336 33.7931 0.455263 33.2828 0.131196 32.6518C-0.0985342 32.1964 -0.0314463 31.9423 0.37109 31.6353L5.93341 27.2704L6.41727 26.8821C6.15094 26.3962 5.90088 25.9043 5.6183 25.4326C5.03889 24.4669 4.39849 23.5358 3.86991 22.5417C3.5443 21.8614 3.28293 21.1522 3.08923 20.4233C2.97538 20.0553 3.14819 19.728 3.42671 19.4372C6.57382 16.1682 10.4182 14.186 14.8238 13.2487C17.4605 12.6818 20.1822 12.6321 22.8379 13.1024L8.70644 24.9447L8.76134 25.026C8.87519 24.9447 8.99106 24.8654 9.10085 24.78L31.0777 7.54412C31.3074 7.36114 31.5656 7.10092 31.8482 7.32455C32.0842 7.50765 32.2448 7.77096 32.2995 8.06457C32.2892 8.20305 32.2515 8.33811 32.1887 8.46198C32.1259 8.58584 32.0392 8.69606 31.9336 8.78629C29.9189 10.553 27.9103 12.3258 25.8346 14.0315C25.0905 14.6414 24.7225 15.2167 24.8181 16.2678C25.0417 18.6688 24.9929 21.1063 25.674 23.4423C26.0541 24.7414 26.6376 25.9815 27.1296 27.2481C27.1764 27.366 27.2191 27.4859 27.2455 27.553L19.0219 30.4663L19.0667 30.6208C19.1622 30.5985 19.2598 30.5822 19.3554 30.5538C22.6346 29.6125 25.9423 28.8033 29.3354 28.3866C30.9923 28.1833 32.6574 28.0084 34.3204 28.3378C34.5923 28.3912 34.8556 28.4815 35.1031 28.6061C35.6805 28.8948 35.8573 29.3766 35.4955 29.9113C35.1659 30.3919 34.7711 30.8243 34.3224 31.1962C33.0172 32.2757 31.529 33.0686 30.0104 33.7964C24.3322 36.5146 18.3795 38.4053 12.2215 39.6698C9.96894 40.1313 7.69807 40.4972 5.38856 40.4484C4.70267 40.4397 4.02023 40.3496 3.35555 40.1801C2.31058 39.9056 2.08493 39.2022 2.77818 38.3809C3.20443 37.8599 3.7068 37.4062 4.26837 37.035C5.539 36.2218 6.86656 35.5163 8.17176 34.7662C8.30594 34.693 8.45028 34.6259 8.62919 34.5324ZM7.50696 39.4116V39.4441C7.8851 39.4055 8.26528 39.377 8.64138 39.3262C9.11914 39.2632 9.59893 39.1981 10.0645 39.1026C16.152 37.8813 22.1082 36.0785 27.8513 33.7192C29.1494 33.1521 30.4182 32.5204 31.6531 31.8264C31.8909 31.7004 32.0271 31.3832 32.2101 31.1535C31.9336 31.064 31.649 30.877 31.3806 30.9014C30.2899 30.9711 29.2039 31.1021 28.1278 31.2938C22.4938 32.4508 16.973 34.1032 11.6299 36.232C10.3003 36.7565 9.01139 37.3908 7.71637 38.0048C7.32886 38.2097 6.96368 38.4543 6.62667 38.7346C6.50469 38.8281 6.45793 39.0192 6.37661 39.1676C6.52703 39.2668 6.68967 39.3461 6.86046 39.4035C7.07526 39.4259 7.29166 39.4286 7.50696 39.4116Z",
    fill: "url(#paint2_linear_702_3897)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.087 12.5857L34.028 14.267L35.38 15.2672L33.7637 15.7328L33.2311 17.3267L32.2898 15.9341L30.6064 15.9178L31.6413 14.5923L31.1371 12.9882L32.7167 13.5636L34.087 12.5857Z",
    fill: "url(#paint3_linear_702_3897)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5494 4.20984L39.4559 6.89952L41.621 8.50153L39.033 9.24561L38.1791 11.797L36.6727 9.56683L33.981 9.54243L35.6379 7.41997L34.8287 4.8543L37.3578 5.77323L39.5494 4.20984Z",
    fill: "url(#paint4_linear_702_3897)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8821 0.174316L31.0287 1.61369L32.8666 1.48561L31.8521 3.02257L32.5433 4.72826L30.7665 4.23831L29.3576 5.42356L29.2742 3.58368L27.7129 2.60783L29.4369 1.96133L29.8821 0.174316Z",
    fill: "url(#paint5_linear_702_3897)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9846 4.04517L24.2977 5.54146L25.7086 6.13104L24.3831 6.89342L24.2591 8.41614L23.1247 7.38947L21.6365 7.74322L22.2627 6.34857L21.4678 5.04134L22.9885 5.20602L23.9846 4.04517Z",
    fill: "url(#paint6_linear_702_3897)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_3897",
    x1: 200.421,
    y1: 13.6212,
    x2: 200.421,
    y2: 35.4598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_3897",
    x1: 217.473,
    y1: 13.6254,
    x2: 217.473,
    y2: 35.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_3897",
    x1: 17.8417,
    y1: 7.23816,
    x2: 17.8417,
    y2: 40.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_702_3897",
    x1: 32.9932,
    y1: 12.5857,
    x2: 32.9932,
    y2: 17.3267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_702_3897",
    x1: 37.801,
    y1: 4.20984,
    x2: 37.801,
    y2: 11.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_702_3897",
    x1: 30.2897,
    y1: 0.174316,
    x2: 30.2897,
    y2: 5.42356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_702_3897",
    x1: 23.5882,
    y1: 4.04517,
    x2: 23.5882,
    y2: 8.41614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EDCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2783EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logoDark.012530c1e5e8c98f82db07038de289f1.svg";
export { ForwardRef as ReactComponent };